import { Form, Input, Select, Button, InputNumber } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PositionSelect } from "../../PositionSelect/PositionSelect";

const { Option } = Select;

export const PlayerForm = ({
  defaultValue = {},
  onSubmit = () => {},
  onCancel = () => {},
}) => {
  const [form] = Form.useForm();

  const { allPositions, allPlayers, sport } = useSelector(({ team }) => team);
  const [pending, setPending] = useState(false);

  const handleSubmit = async () => {
    setPending(true);
    try {
      const values = await form.validateFields();
      await onSubmit({ ...defaultValue, ...values });
      handleCancel();
    } catch (e) {
      console.log(e);
      return;
    }
    setPending(false);
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  useEffect(() => {
    form.resetFields(["first_name", "Hello"]);
  }, []);

  const checkFullName = (getFieldValue) => {
    const firstName = getFieldValue("first_name")?.trim() || "";
    const lastName = getFieldValue("last_name")?.trim() || "";
    const foundPlayers = allPlayers.filter(
      ({ first_name, last_name, player_id }) => {
        return (
          first_name === firstName &&
          last_name === lastName &&
          player_id !== defaultValue?.player_id
        );
      }
    );
    return foundPlayers.length === 0;
  };

  const checkEmail = (getFieldValue) => {
    const email = getFieldValue("email")?.trim() || "";
    const foundPlayers = allPlayers.filter(
      ({ email: playerEmail, player_id }) => {
        return playerEmail === email && player_id !== defaultValue?.player_id;
      }
    );
    return foundPlayers.length === 0;
  };

  const nameValidator = ({ getFieldValue }) => ({
    validator(_, value) {
      if (checkFullName(getFieldValue)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Same name already exists"));
    },
  });

  const emailValidator = ({ getFieldValue }) => ({
    validator(_, value) {
      if (checkEmail(getFieldValue)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Same email already exists"));
    },
  });

  const positionValidator = ({ getFieldValue }) => ({
    validator(_, value) {
      if (
        !getFieldValue("position") ||
        allPositions.includes(getFieldValue("position"))
      ) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Position is not recognized"));
    },
  });

  useEffect(() => {
    if (defaultValue === null) form.resetFields();
    else {
      form.setFieldsValue(defaultValue);
      form.validateFields();
    }
  }, [defaultValue]);

  return (
    <Form
      form={form}
      name="player-form"
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
    >
      <Form.Item
        label="First Name"
        name="first_name"
        rules={[
          { required: true, message: "Please input first name" },
          nameValidator,
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Last Name"
        name="last_name"
        rules={[
          { required: true, message: "Please input last name" },
          nameValidator,
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Position"
        name="position"
        rules={[
          { required: true, message: "Please select position" },
          positionValidator,
        ]}
      >
        <PositionSelect
          options={allPositions}
          sport={sport}
          value={form.getFieldValue("position")}
          handleChange={(value) => form.setFieldsValue({ position: value })}
        />
      </Form.Item>
      <Form.Item
        label="Jersey Number"
        name="number"
        rules={[{ required: true, message: "Please input jersey number" }]}
      >
        <Input type="number" min={0} />
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { type: "email", message: "Email is not a valid email" },
          emailValidator,
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 16, span: 8 }}>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          type="primary"
          style={{ margin: "0 8px" }}
        >
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};
